import React from 'react';
import { t } from '../../services/i18nService';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './generalErrorPage.scss';

class ResponseNotProcessedPage extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    onCloseClick() {
        if (window.bridgeCallbacks) {
            window.bridgeCallbacks.closeWindow();
        } else {
            window.close();
        }
    }

    render() {
        return (
            <div className={styles.errorPage} role="main">
                <i className="fa fa-clone fa-2x" />
                <p className="title">{t('ResponseNotProcessedPage.title')}</p>
                <p className="message">{t('ResponseNotProcessedPage.message')}</p>
                <button className={styles.closeButton} onClick={this.onCloseClick}>
                    {t('general.close')}
                </button>
            </div>
        );
    }
}

export default ResponseNotProcessedPage;
